angular.module('tasks')
    .component('taskBtnOptions', {
        bindings: {
            item: '=',
            largeButton: '=',
            onExecute: '&'
        },
        templateUrl: "app/task/task-btn-options.html",
        controller: function (Task, TaskService, FilesLibrary, FilesSimpleUploadService) {
            this.TaskService = TaskService
            this.FilesLibrary = FilesLibrary
            this.FilesSimpleUploadService = FilesSimpleUploadService

            this.fileResourceName = 'TASK'
            this.executeBeforeAction = this.onExecute || angular.noop;

            this.attachFile = () => FilesSimpleUploadService.open({type: this.fileResourceName, id: this.item.id});
            this.attachLibraryFile = () => FilesLibrary.openAndBind({type: this.fileResourceName, id: this.item.id});

            this.isTaskDone = () => this.item?.done

            this.edit = () => {
                Task.get({id: this.item.id}, entity => {
                    this.executeBeforeAction()
                    TaskService.editModal(entity)
                })
            }
            this.clone = () => {
                this.executeBeforeAction()
                TaskService.clone(this.item.id)
            }
            this.cloneWithTime = (cloneValue, clonePeriod) => {
                this.executeBeforeAction()
                TaskService.cloneWithTime(this.item.id, cloneValue, clonePeriod)
            }
            this.delete = () => TaskService.remove(this.item).then(() => this.executeBeforeAction(), () => {})
        }
    })
